import { useTranslation } from "react-i18next";
import { AnnouncementsComponent } from "../../components/AnnouncementsComponents";
import { requestAnnouncements } from "../../requests/setup_requests";
import { useContext, useEffect, useState } from "react";
import { AccountContext } from "../../contexts/AccountContexts";
import { requestTicketMemberHistory } from "../../requests/ticket_requests";
import { ContentContext } from "../../contexts/ContentContext";
import { formatTimestamp } from "../../utils";
import { useNavigate } from "react-router-dom";
import { loadingActive } from "../../components/Background";
import { statusToUserStatus } from "../../entries";
import { PageHeader } from "../../components/HeaderComponents";

export const UserTicketHistoryPage = () => {
  const { t } = useTranslation("common");
  const { user, language } = useContext(AccountContext);
  const { categories, servers, openErrorModal } = useContext(ContentContext);

  const [ticketHistory, setTicketHistory] = useState([]);

  useEffect(() => {
    if (user?.class === "user") {
      loadingActive(true);
      requestTicketMemberHistory({})
        .then((data) => {
          setTicketHistory(data.tickets);
        })
        .catch((error) => {
          openErrorModal(error);
        })
        .finally(() => {
          loadingActive(false);
        });
    }
  }, [user]);

  return (
    <div className="flex flex-col items-center gap-5  pb-10 px-[2px]">
      <PageHeader pageTitle={t("Ticket History")} />

      <div className="flex flex-col items-center w-full mx-auto max-w-[1200px] min-h-screen bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded-xl shadow-sm pb-12 py-5 px-3 sm:p-5 gap-4">
        <span className="text-blue-900 dark:text-blue-500 font-semibold text-xl">
          {t("Ticket History")}
        </span>
        <div className="overflow-x-auto w-full">
          <table className="table  w-full">
            <thead className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300">
              <tr className="border-gray-300 dark:border-gray-600">
                <th className="max-w-xs truncate">{t("TICKET ID")}</th>
                <th className="max-w-xs truncate sm:hidden">{t("STATUS")}</th>
                <th className="max-w-xs truncate">{t("CATEGORY")}</th>
                <th className="max-w-xs truncate">{t("SERVER")}</th>
                <th className="max-w-xs truncate">{t("CHARACTER")}</th>
                <th className="max-w-xs truncate">{t("CREATED")}</th>
                <th className="max-w-xs truncate">{t("UPDATED")}</th>
                <th className="max-w-xs truncate hidden sm:flex">
                  {t("STATUS")}
                </th>
              </tr>
            </thead>
            <tbody className="">
              {ticketHistory.map((ticket, _) => (
                <tr
                  key={ticket.id}
                  className="h-20 border-gray-300 dark:border-gray-600"
                >
                  <td className="max-w-xs truncate">
                    <span>
                      <TicketButtonMember ticket={ticket} />
                    </span>
                  </td>
                  <td className="max-w-xs truncate sm:hidden">
                    <TicketStatus status={ticket.status} />
                  </td>
                  <td className="max-w-xs truncate">
                    <span>
                      {t(
                        (categories[ticket.category]?.locales?.[language]
                          ? categories[ticket.category]?.locales[language]
                          : categories[ticket.category].title) ?? "UNK",
                      )}
                    </span>
                  </td>
                  <td className="max-w-xs truncate">
                    <span>{servers[ticket.server]?.title ?? "UNK"}</span>
                  </td>
                  <td className="max-w-xs truncate">
                    <span>{ticket.characterName}</span>
                  </td>
                  <td className="max-w-xs truncate">
                    <span>{formatTimestamp(ticket.createdAt * 1000)}</span>
                  </td>
                  <td className="max-w-xs truncate">
                    <span>{formatTimestamp(ticket.lastUpdated * 1000)}</span>
                  </td>
                  <td className="max-w-xs truncate hidden sm:table-cell">
                    <TicketStatus status={ticket.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {ticketHistory.length === 0 && (
          <span className="w-full text-center italic">
            {t("No entries found", { ns: "common" })}
          </span>
        )}
      </div>
    </div>
  );
};

const TicketStatus = ({ status }) => {
  const { t } = useTranslation("common");
  const renderStatus = statusToUserStatus[status];

  return (
    <span className={`${renderStatus.style}`}>{t(renderStatus.title)}</span>
  );
};

const TicketButtonMember = ({ ticket }) => {
  const navigator = useNavigate();
  const { t } = useTranslation("common");

  const to = `/member/ticket/${ticket.fetch_code}`;

  const handleClick = (e) => {
    e.preventDefault();
    if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      navigator(to);
    }
  };

  return (
    <>
      <button
        className=" group label border rounded-lg p-2 py-3 bg-white dark:bg-gray-700 border-primary dark:border-blue-600 hover:bg-primary hover:text-white relative"
        onClick={handleClick}
        href={to}
        target="_self"
        rel="noopener noreferrer"
      >
        <span className="font-normal text-center  max-w-40 transition-all duration-200 px-2">
          {ticket.createdAt}
        </span>
      </button>
    </>
  );
};
